// extracted by mini-css-extract-plugin
module.exports =  {"facet":"pl__Facet-module__facet___kHdeM","facet__title":"pl__Facet-module__facet__title___AQefi"};